import { createGlobalStyle, ThemeProvider } from "styled-components";
import { ThemeLight } from "theme/light/light.theme";
import { ThemeDark } from "theme/dark/dark.theme";
import { GlobalStyle } from "theme/theme.utils";
import {
  getLocalStorageItem,
  LocalStorageKeys,
} from "utils/react/localStorage";
import { ReactNode, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { setTheme } from "store/tableSlice/index.slice";
import { IThemeNames } from "theme/theme.type";

// Define once at module scope
const Global = createGlobalStyle<{ $theme: IThemeNames }>`
  :root {
    ${props => GlobalStyle(props.$theme === "light" ? ThemeLight : ThemeDark)}
  }
`;

export const ReduxThemeProvider = ({ children }: { children: ReactNode }) => {
  const { theme } = useSelector((state: RootState) => state.tableSlice);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setTheme(
        (getLocalStorageItem(LocalStorageKeys.CONNEXX_THEME) as IThemeNames) ||
          "light"
      )
    );
  }, []);

  return (
    <>
      <Global $theme={theme} />
      <ThemeProvider theme={theme === "light" ? ThemeLight : ThemeDark}>
        {children}
      </ThemeProvider>
    </>
  );
};
